import { Link } from "react-router-dom";
import { Share2, ArrowRight } from "lucide-react";
import ShareEventCard from "@/components/ShareEventCard";

/** Dashboard strip nudging logged-in runners to share the featured event. */
export default function ShareEventPromo({ event }) {
  if (!event?.enabled || !event?.title) return null;
  const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(event.date || "");
  if (m && new Date(`${event.date}T05:30:00+05:30`).getTime() < Date.now() - 12 * 60 * 60 * 1000) return null;

  return (
    <section
      data-testid="share-event-promo"
      className="mt-6 relative hairline border-orange-600/40 bg-zinc-950 overflow-hidden"
    >
      <div className="absolute inset-0 pointer-events-none bg-[radial-gradient(ellipse_at_left,rgba(234,88,12,0.18),transparent_60%)]" aria-hidden="true" />
      <div className="relative px-6 sm:px-8 py-6 flex flex-col md:flex-row md:items-center justify-between gap-5">
        <div className="min-w-0">
          <p className="font-mono text-[10px] tracking-[0.3em] text-orange-500 uppercase">SPREAD THE WORD</p>
          <h3 className="font-display text-2xl sm:text-3xl text-white mt-1.5">
            Tell your friends you&apos;re running <span className="text-orange-500">{event.title}.</span>
          </h3>
          <p className="text-sm text-zinc-400 mt-1.5 max-w-xl">
            One tap creates a personalised poster with your name for Instagram and WhatsApp — every share brings a new runner to the pack.
          </p>
        </div>
        <div className="flex flex-wrap gap-2 shrink-0">
          <ShareEventCard event={event}>
            <button
              type="button"
              data-testid="dashboard-share-event-btn"
              className="inline-flex items-center gap-2 bg-orange-600 hover:bg-orange-500 text-white font-display tracking-wider px-5 py-3 transition"
            >
              <Share2 size={16} /> CREATE MY POSTER
            </button>
          </ShareEventCard>
          <Link
            to="/"
            data-testid="dashboard-share-event-details"
            className="inline-flex items-center gap-1 border border-zinc-700 text-white hover:bg-zinc-900 font-display tracking-wider px-5 py-3 transition"
          >
            EVENT DETAILS <ArrowRight size={14} />
          </Link>
        </div>
      </div>
    </section>
  );
}
